import { pageView } from '@services/analytics';
import { useContext, useEffect } from 'react';
import { UNSAFE_DataRouterStateContext } from 'react-router';
import { useScreenName } from './useScreenName';

/**
 * Fires `page_view` on every route change. Web fires `page_view` (per spec
 * §4.1); mobile is the only platform that fires `screen_view`.
 * vite.config.ts sets `send_page_view: false` so GA4 doesn't auto-emit on
 * initial load — this hook is the only place page_view originates.
 *
 * The screen identity comes from the active route's `handle.screen_name`
 * (see `useScreenName`). Mount once at the layout level (both `RootLayout`
 * and `RootLayoutWithoutNav`).
 */
export function usePageView(): void {
    const screen = useScreenName();
    const pathname = useContext(UNSAFE_DataRouterStateContext)?.location
        ?.pathname;

    useEffect(() => {
        if (screen) pageView({ screen_name: screen });
    }, [screen, pathname]);
}
